<ng-container *transloco="let t">
    @if (title) {
        <h1 align="center" mat-dialog-title>{{t(title)}}</h1>
    }
    <div mat-dialog-content>
        <p>
            {{t(message)}}
        </p>
    </div>
    <div mat-dialog-actions align="center">
        <button mat-raised-button color="warn" mat-dialog-close>
            {{t(cancelButtonText)}}
        </button>
    </div>
</ng-container>
